import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';

const namespace = 'features.time_entries.index.mass_actions';

function ExportButton({
  queryParams,
  selectedIds,
  selectAll,
  exportPath,
  translationKey,
  iconClassName
}) {
  const [loading, setLoading] = useState(false);
  const nothingSelected = selectedIds.length === 0 && !selectAll;

  const handleExport = () => {
    setLoading(true);
    window.location = `${exportPath()}?${queryParams}`;
    setLoading(false);
  };

  return (
    <button type="button" tabIndex="0" className="qmb-control" disabled={loading || nothingSelected} onClick={handleExport}>
      <i className={iconClassName} />
      {loading ? translate('exporting', { namespace }) : translate(translationKey, { namespace })}
    </button>
  );
}

ExportButton.propTypes = {
  queryParams: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectAll: PropTypes.bool.isRequired,
  exportPath: PropTypes.func.isRequired,
  translationKey: PropTypes.string.isRequired,
  iconClassName: PropTypes.string
};

ExportButton.defaultProps = {
  iconClassName: 'fa-light fa-file-export'
};

export default ExportButton;
